import React, { useEffect, useState } from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch, useSelector } from "react-redux";
import { jobLoadAction } from "../../redux/actions/jobAction";
import CreateJob from "../CreateJobs";
import { BiArrowBack } from "react-icons/bi";
import CreateCompany from "../CreateCompany";
import { companyLoadAction } from "../../redux/actions/company";
import axios from "axios";
import { toast } from "react-toastify";

const DashCompany = () => {
  const dispatch = useDispatch();
  const [create, setCreate] = useState(true);
  const { userInfo } = useSelector((state) => state.signIn);

  useEffect(() => {
    dispatch(companyLoadAction());
  }, []);

  const { company } = useSelector((state) => state.getCompanies);
  let data = [];
  data = company !== undefined && company.length > 0 ? company : [];

  //delete job by Id
  const deleteCompanyById = async (e, id) => {
    try {
      console.log("hi");
      const config = {
        headers: { Authorization: "Bearer " + userInfo.token },
      };
      console.log(id);
      await axios.delete(`/api/company/${id}`, config);
      dispatch(companyLoadAction());
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  const verifyCompany = async (e, id) => {
    try {
      await axios.patch(`/api/user/verifyUser/${id}`);
      dispatch(companyLoadAction());
      toast.success("Company is verified");
    } catch (err) {
      console.log(err);
      toast.error(err.response.data.message);
    }
  };
  const columns = [
    {
      field: "_id",
      headerName: "Company ID",
      width: 150,
      editable: true,
    },
    {
      field: "title",
      headerName: "Company name",
      width: 150,
      valueGetter: (data) => data.row.name,
    },
    {
      field: "location",
      headerName: "location",
      width: 150,
      valueGetter: (data) => data.row.location,
    },
    {
      field: "owner",
      headerName: "Owner",
      width: 150,
      valueGetter: (data) => data.row.owner?.username,
    },
    {
      field: "Status",
      headerName: "Status",
      width: 150,
      valueGetter: (data) =>
        data.row.owner?.pending ? "pending..." : "Verified",
    },
    {
      field: "Documents",
      headerName: "Documents",
      width: 150,
      valueGetter: (data) =>
        data.row.document ? data.row.document.url : "document",
    },
    {
      field: "Actions",
      width: 300,
      renderCell: (values) => (
        <Box
          sx={{
            display: "flex",
            width: "300px",
          }}
        >
          <Button
            onClick={(e) => deleteCompanyById(e, values.row._id)}
            variant="contained"
            color="error"
          >
            Delete
          </Button>
          <Button
            onClick={(e) => verifyCompany(e, values.row.owner._id)}
            variant="contained"
            color="success"
            sx={{
              marginLeft: "10px",
            }}
          >
            Verify
          </Button>
          <a
            href={values.row.document?.url}
            target="_blank"
            rel="noopener noreferrer"
            download
          >
            <Button
              variant="contained"
              color="info"
              sx={{
                marginLeft: "10px",
              }}
            >
              download
            </Button>
          </a>
        </Box>
      ),
    },
  ];

  return (
    <Box>
      <Typography variant="h4" sx={{ color: "white", pb: 3 }}>
        Company list
      </Typography>
      {create ? (
        <>
          <Box sx={{ pb: 2, display: "flex", justifyContent: "right" }}>
            <Button
              onClick={() => setCreate(!create)}
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
            >
              {" "}
              Create Company
            </Button>
          </Box>
          <Paper
            sx={{
              bgcolor: "secondary.midNightBlue",
            }}
          >
            <Box sx={{ height: 400, width: "100%" }}>
              <DataGrid
                getRowId={(row) => row._id}
                sx={{
                  "& .MuiTablePagination-displayedRows": {
                    color: "white",
                  },
                  color: "white",
                  [`& .${gridClasses.row}`]: {
                    bgcolor: (theme) =>
                      // theme.palette.mode === 'light' ? grey[200] : grey[900],
                      theme.palette.secondary.main,
                  },
                  button: {
                    color: "#ffffff",
                  },
                }}
                rows={data}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
              />
            </Box>
          </Paper>
        </>
      ) : (
        <>
          <CreateCompany />
          <BiArrowBack
            style={{
              color: "white",
              fontSize: "3rem",
            }}
            onClick={() => setCreate(!create)}
          />
        </>
      )}
    </Box>
  );
};

export default DashCompany;
